import React, { Suspense } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { useSelector } from "react-redux";

import * as layoutConstants from "../constants/layout";

// All layouts/containers
import DefaultLayout from "../layouts/Default";
import VerticalLayout from "../layouts/Vertical";
import FullScreenLayout from "../layouts/FullScreen";

import {
  authProtectedFlattenRoutes,
  publicProtectedFlattenRoutes,
} from "./index";

import GlobalActivitySpeedDial from "../components/GlobalActivitySpeedDial";
import CallPanel from "../components/telephony/CallPanel";

const Routes = (props) => {
  const { layout, user } = useSelector((state) => ({
    layout: state.Layout,
    user: state.Auth.user,
  }));

  const getLayout = () => {
    let layoutCls = VerticalLayout;

    switch (layout.layoutType) {
      case layoutConstants.LAYOUT_FULL_SCREEN:
        layoutCls = FullScreenLayout;
        break;
      default:
        layoutCls = VerticalLayout;
        break;
    }
    return layoutCls;
  };

  let Layout = getLayout();

  return (
    <BrowserRouter>
      <Switch>
        <Route path={publicProtectedFlattenRoutes.map((r) => r["path"])}>
          <DefaultLayout {...props} layout={layout}>
            <Switch>
              {publicProtectedFlattenRoutes.map((route, index) => {
                return (
                  !route.children && (
                    <route.route
                      key={index}
                      path={route.path}
                      roles={route.roles}
                      exact={route.exact}
                      component={route.component}
                    />
                  )
                );
              })}
            </Switch>
          </DefaultLayout>
        </Route>

        <Route path={authProtectedFlattenRoutes.map((r) => r["path"])}>
          {/* Aktivitaet/Aufgabe von ueberall anlegen. Tritt zurueck, wo ein
              Firmen-Verlauf seinen eigenen Plus-Knopf mitbringt. Die Suspense-Grenze
              ist Pflicht: useTranslation laedt die Namespaces nach und haelt den
              ersten Render an — hier steht, anders als beim Seiteninhalt, keine
              Grenze des Layouts darum. */}
          <Suspense fallback={null}>
            <GlobalActivitySpeedDial />
            {/* Das Protokollfenster eines laufenden Anrufs. Es steht HIER, ausserhalb
                des <Switch> — nur deshalb ueberlebt es einen Seitenwechsel, und genau
                das ist sein Zweck: waehrend des Gespraechs weitersuchen koennen. */}
            <CallPanel />
          </Suspense>
          <Layout {...props} layout={layout} user={user}>
            <Switch>
              {authProtectedFlattenRoutes.map((route, index) => {
                return (
                  !route.children && (
                    <route.route
                      key={index}
                      path={route.path}
                      roles={route.roles}
                      exact={route.exact}
                      component={route.component}
                    />
                  )
                );
              })}
            </Switch>
          </Layout>
        </Route>
      </Switch>
    </BrowserRouter>
  );
};

export default Routes;
